export const brandName = 'Langwood Tutoring';

export const contactDetails = {
  phoneDisplay: '0411 793 595',
  phoneHref: 'tel:+61411793595',
  whatsappHref: 'https://wa.me/61411793595',
  email: 'langwoodtutoring@gmail.com',
  emailHref: 'mailto:langwoodtutoring@gmail.com',
  emailSubject: 'Tutoring Enquiry',
};

export const trustMessage = 'Trusted by Melbourne families';

export const siteContent = {
  header: {
    brandLabel: `${brandName} home`,
    ctaLabel: 'Book a Session',
  },
  hero: {
    heading: 'Confident Tutoring for Every Kind of Student',
    message: 'Experienced support for Melbourne students in literacy, numeracy, science, and critical thinking. We help students find their space and make progress in their education.',
    ctaLabel: 'Book a Session',
    ctaHref: '#contact',
  },
  socialProof: {
    ariaLabel: 'Langwood tutoring highlights',
    badges: [
      {
        value: 'Founder-led tutoring',
        label: 'Warm, tailored support',
      },
      {
        value: 'Small groups + 1:1',
        label: 'Flexible session formats',
      },
      {
        value: 'Literacy • Numeracy • Science • Critical Thinking',
        label: 'Core subjects covered',
      },
    ],
  },
  services: {
    heading: 'What We Teach',
    message: 'Four focused subjects, taught with clarity and consideration',
    items: [
      {
        icon: 'literacy',
        title: 'Literacy',
        description: 'Reading, writing, and comprehension development that builds confidence, interest, and better classroom habits.',
      },
      {
        icon: 'numeracy',
        title: 'Numeracy',
        description: 'A focus on concept comprehension rather than the memory based approach to Mathematics that makes so many students switch off.',
      },
      {
        icon: 'science',
        title: 'Science',
        description: 'All areas of science are taught in a way that builds engagement and makes core ideas click.',
      },
      {
        icon: 'critical-thinking',
        title: 'Critical Thinking',
        description: 'Langwood Tutoring is passionate about providing students with essentials that are sadly lacking from our schools. We have tailored a program that will benefit students in all their school subjects and improve the perception they have of their education.',
      },
    ],
  },
  about: {
    eyebrow: 'Founder story',
    heading: 'Founding Principles',
    sentences: [
      'Langwood Tutoring was founded to fill the potential in private tutoring that other companies ignore.',
      'Instead of just giving more time to students to try the same approach that they\'re struggling with, we provide tailored support so students are helped in finding what allows them to move forward.',
      'We consider the student first and have found consistent success in this approach.',
    ],
    trustLabel: 'Parent trust',
    trustLine: trustMessage,
    trustDetail: 'A local tutoring experience that stays warm, personal, and easy to trust.',
    reviewsHref: 'https://www.google.com/search?q=Langwood+Tutoring+Reviews&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOTo9i0_ln6QZ7T7mdvyLatGR5O1tk5eEthK_SRVifgH96I4ukOHtC0SzZvVXIL47daJf03DrrMZZblktMo2YhcPkY4Gz-zaPDdt3cnxaW2W3LuAw7g%3D%3D',
    reviewsLabel: 'Read our Google reviews →',
  },
  staff: {
    eyebrow: 'Tutor team',
    heading: 'Meet the Team',
    intro: 'Experienced tutors supporting literacy, numeracy, and science across primary and secondary years.',
    empty: 'Fresh staff profiles are being prepared. Get in touch and we’ll match you with the right tutor.',
    fallback: 'Live staff details are temporarily unavailable, so you’re seeing our default team profile cards.',
  },
  pricing: {
    heading: 'Pricing',
    message: 'Two simple lesson formats, with the same warm and structured support.',
    ctaLabel: 'Talk Through the Options',
    ctaCopy: 'Not sure which format fits best? We’ll point you to the right starting option.',
    options: [
      {
        title: 'Group',
        label: 'Small-group tutoring',
        price: '$60',
        suffix: '/session',
        description: 'Shared momentum for students who learn well alongside others.',
      },
      {
        title: 'Individual',
        label: 'One-to-one tutoring',
        price: '$80',
        suffix: '/session',
        description: 'A tailored pace for students who need focused support.',
      },
    ],
  },
  contact: {
    heading: 'Start With a Quick Chat',
    message: 'Tell us what your child needs help with and we’ll recommend the best next step.',
    callLabel: `Call ${contactDetails.phoneDisplay}`,
    whatsappLabel: 'Message on WhatsApp',
    emailLabel: 'Email Us',
    form: {
      nameLabel: 'Name',
      emailLabel: 'Email',
      phoneLabel: 'Phone (optional)',
      messageLabel: 'How can we help?',
      submitLabel: 'Send Message',
      sendingLabel: 'Sending…',
      success: 'Thanks — we’ve received your message.',
      error: 'Please enter a valid email and a short message.',
      muted: 'No form service configured yet — your email app will open to send this enquiry.',
    },
    sticky: {
      call: 'Call',
      email: 'Email',
      whatsapp: 'WhatsApp',
    },
  },
};

export default siteContent;
